import { ProjectHelper } from 'src/app/core/utils/project.helper';

import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AssetFile, AssetUrl } from '@brafton/assets-api';

@Component({
  selector: 'content-project-image',
  templateUrl: './content-project-image.component.html',
  styleUrls: ['./content-project-image.component.scss'],
  host: { class: 'content-project-image' },
})
export class ContentProjectImageComponent implements OnInit {
  @Input() project?: any;
  @Input() size = 120;
  @Input() details = true;
  @Input() showMembers?: boolean = true;
  @Input() opens: 'Project' | 'Asset' = 'Project';
  @Input() compressed = false;

  assetFile!: AssetFile;

  @Output() loaded = new EventEmitter<boolean>();
  @Output() errored = new EventEmitter<boolean>();

  @HostBinding('class.compressed') get compressedChecker() {
    return this.compressed == true;
  }

  constructor(private router: Router, private projectHelper: ProjectHelper) {}

  ngOnInit() {
    if (this.project && this.project?.defaultAsset) {
      this.assetFile = this.project?.defaultAsset?.assetFiles[0];
    }
  }

  openLink() {
    if (this.opens === 'Project' && this.project) {
      const route = this.projectHelper.findProjectRoute(this.project);
      this.router.navigate([route]);
    }

    if (this.opens === 'Asset' && this.assetFile) {
      const assetUrlPipe = new AssetUrl();
      window.open(assetUrlPipe.transform(this.assetFile, 'preview'));
    }
  }
}
